import React, { useEffect, useState } from 'react';
import Modal from '../Modal/Modal';
import ConfirmAndCancel from '../Buttons/ConfirmAndCancel';
import Moment from 'react-moment';
import FormDropdown from "../FormField/FormDropdown";

function CancelBookingPopupCollege({
  show,
  onClose,
  onConfirm,
  booking,
  campus,
  level,
  cancelSingleDay,
  setCancelReason,
  setCancelPenaltyPercent,
  selectedDate,
  inst,
}) {
  const {
    booking_date,
    end_booking_date,
    start_time,
    teacher_id,
    teacher_response,
  } = booking;

  const teacherText = inst?.is_childcare_centre ? "Educator" : "Teacher"

  if (!campus || !campus._id && booking?.campus) {
    campus = booking.campus
  }

  // Calculates number of hours until class starting time

  /*
  const bookingDateTime = `${booking_date} ${start_time}`;
  const diffInMilliSeconds =
    Date.parse(bookingDateTime) - Date.parse(new Date());
  const hoursUntilClass = diffInMilliSeconds / (1000 * 60 * 60);
  // console.log('Hours until class: ', hoursUntilClass);

  const callUs = <a href='tel:1800732398'>call us at 1800 READYT</a>;
   */

  const adminFee = 50
  const [cancelPopupMessages, setCancelPopupMessages] = useState("");
  let cancelPopupMessage = ""

  let teacherAllocated = booking.teacher && booking.teacher._id && teacher_response === 'accepted';

  const getValidStartDate = (booking) => {
    if (!booking?.multiple_date) {
      return booking.booking_date
    }

    if(selectedDate?.date) {
      return booking.dates?.find(item => item.date >= selectedDate?.date)?.date
    } else {
    return booking.dates?.find(item => item.date >= booking.booking_date)?.date
    }
  }

  function businessHoursBetweenDates(startDate, endDate) {
    let minutesWorked = 0;
    if (endDate < startDate) {
      return -1;
    }
    // Loop from your Start to End dates (by hour)
    let current = startDate;

    // Loop while currentDate is less than end Date (by minutes)
    while (current <= endDate){
      // Is the current time within a work day (and if it occurs on a weekend or not)
      if (current.getDay() !== 0 && current.getDay() !== 6){
        minutesWorked++;
      }
      current.setTime(current.getTime() + 1000 * 60);
    }
    return minutesWorked / 60;
  }

  const startDate = getValidStartDate(booking) || booking_date;
  const bookingTime = new Date(`${startDate}T${start_time}`);
  const hoursUntilClass = businessHoursBetweenDates(new Date(), bookingTime);

  const checkMessagePopup = () => {
    const noTeacherAllocMsg = (
      <strong>
        {inst?.is_childcare_centre ? "No educator" : "No teacher"} is assigned to this booking. You will not need to pay a
        cancellation fee.
      </strong>
    );
  
    if (hoursUntilClass < 0) {
      cancelPopupMessage = teacherAllocated ? (
        <strong>
          You are unable to cancel bookings that have passed their starting time - please contact admin.
        </strong>
      ) : (
        noTeacherAllocMsg
      );
    } else if (hoursUntilClass < 48) {
      if (teacherAllocated) {
        setCancelPenaltyPercent(1)
      }
      cancelPopupMessage = teacherAllocated ? (
        <strong>
          You are attempting to cancel this booking within 48 hours of
          commencement. Please note: Booking cancellations in the event that 
          a {teacherText} has already been allocated will incur a Cancellation Fee of 100%
          of wages and admin fee of ${adminFee}. Do you wish to proceed with cancelling this booking?
        </strong>
      ) : (
        noTeacherAllocMsg
      );
    } else if (hoursUntilClass < 96) {
      if (teacherAllocated) {
        setCancelPenaltyPercent(0.5)
      }
      cancelPopupMessage = teacherAllocated ? (
        <strong>
          You are attempting to cancel this booking within 4 business days of
          commencement. Please note: Booking cancellations in the event that 
          a {teacherText} has already been allocated will incur a Cancellation Fee of 50%
          of wages and admin fee of ${adminFee}. Do you wish to proceed with cancelling this booking?
        </strong>
      ) : (
        noTeacherAllocMsg
      );
    } else if (hoursUntilClass < 168) {
      if (teacherAllocated) {
        setCancelPenaltyPercent(0.25)
      }
      cancelPopupMessage = teacherAllocated ? (
        <strong>
          You are attempting to cancel this booking within 7 business days of
          commencement. Please note: Booking cancellations in the event that 
          a {teacherText} has already been allocated will incur a Cancellation Fee of 25%
          of wages and admin fee of ${adminFee}. Do you wish to proceed with cancelling this booking?
        </strong>
      ) : (
        noTeacherAllocMsg
    )} else {
      cancelPopupMessage = teacherAllocated ? (
        <>
          <strong>
            {' '}
            You are cancelling outside 7 days from the start date of your booking. No fees apply.
          </strong>
          <br />
          <br />
        </>
      ) : (
        noTeacherAllocMsg
      );
    }
    setCancelPopupMessages(cancelPopupMessage)
  }

  useEffect(() => {
    checkMessagePopup()
  }, [])

  const cancelReasonChange = (reason) => {
    setCancelReason(reason)
    if (reason === "Public holiday" && hoursUntilClass >= 0) {
      cancelPopupMessage = <strong>
        Cancellation of a public holiday does not incur a cancellation fee.
      </strong>
      setCancelPopupMessages(cancelPopupMessage)
      setCancelPenaltyPercent(0)
    }
    else {
      checkMessagePopup()
    }
  }

  return (
    <Modal
      show={show}
      onClose={onClose}
      header='Cancel Booking'
      className='delete-modal'
    >
      <p className='center-text my-3'>
        <span>
          <Moment format='DD MMM YYYY'>{getValidStartDate(booking)}</Moment>
          {end_booking_date && end_booking_date !== getValidStartDate(booking) && (
            <>
              {' - '}
              <Moment format='DD MMM YYYY'>{end_booking_date}</Moment>
            </>
          )}
        </span>
        <br />
        <span>
          {
            campus ?
              `${level} @ ${campus.address_line1 + (campus.address_line2 ? ', ' + campus.address_line2 : '')}` : ''
          }
          
        </span>
      </p>
      {cancelPopupMessages}
      <FormDropdown
        label="Choose reason for cancellation"
        id="cancel-reason"
        className={cancelSingleDay && hoursUntilClass >= 0 ? "mt-5" : " d-none"}
        // value={}
        onChange={(e) => cancelReasonChange(e.target.value)}
        required
      >
        <option value=''>Please Choose</option>
        <option value='Public holiday'>Public holiday</option>
        <option value='College closure'>College closure</option>
        <option value='Class cancelled'>Class cancelled</option>
        <option value={`${teacherText} no longer required`}>{teacherText} no longer required</option>
      </FormDropdown>
      {(hoursUntilClass < 0 && teacherAllocated) || (
        <ConfirmAndCancel
          onCancel={onClose}
          cancelText='Go Back'
          onConfirm={() => {
            onConfirm();
            onClose();
          }}
          confirmText='Cancel Booking'
        />
      )}
    </Modal>
  );
}

export default CancelBookingPopupCollege;
